import { DropdownInput } from "@validereinc/common-components";
import { UserTypeEnum } from "@validereinc/domain";
import React from "react";

const USER_TYPE_OPTIONS = [
  { label: "Human", value: UserTypeEnum.human },
  { label: "Machine", value: UserTypeEnum.machine },
] as const;

export const UserTypeDropdownInput = ({
  onChange,
}: {
  onChange: (val: string[]) => void;
}) => {
  return (
    <DropdownInput
      name="type"
      defaultValue={[UserTypeEnum.human, UserTypeEnum.machine]}
      options={[...USER_TYPE_OPTIONS]}
      labelKey="label"
      valueKey="value"
      placeholder="Filter by type"
      isMulti
      isInline
      isOptionalTextShown={false}
      isLabelShown={false}
      onChange={(val) => onChange(Array.isArray(val) ? val : [])}
    />
  );
};
